import { useState, useEffect } from "react";
import "./NewVersionToast.css";
import Action from "./../formElements/Action/Action";
import { isUserAuthenticated } from "./../../services/authUtil";
import { refreshWebapp, fetchLatestBuildVersion } from "../../services/buildVersion";

const FETCH_VERSION_PERIOD = 60 * 1000;
let runningVersion: string;

const NewVersionToast = () => {
  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const latestVersion = await fetchLatestBuildVersion();
      if (!runningVersion) {
        runningVersion = latestVersion;
      }

      if (latestVersion !== runningVersion) {
        setToastShown(true);
      }
    }, FETCH_VERSION_PERIOD);

    return () => clearInterval(intervalId);
  }, []);

  if (toastShown && isUserAuthenticated()) {
    return (
      <div className="new-version-toast">
        <div className="toast-inner">
          <span>A new version is available.</span>
          <Action className="btn" onClick={refreshWebapp}>
            REFRESH
          </Action>
        </div>
      </div>
    );
  }

  return null;
};

export default NewVersionToast;
